import React, { useEffect, useRef, useState } from "react";
import ContentLoader from "react-content-loader" // Create skeleton here: https://skeletonreact.com/
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as commonActions from "../../redux/commonActions";
import { createApp, updateApp } from "../../redux/commonCrud";
import { ContentEditor, FilePreviewer, FileUploader, PageTitle, PortfolioCard, PortfolioCategories } from "../../../martin/_partials";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Formik } from "formik";
import * as Yup from "yup";
import Alert from '@material-ui/lab/Alert'; // https://material-ui.com/components/alert/#simple-alerts
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Chip from '@material-ui/core/Chip';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { appConfigs, formatInputDate } from "../../../martin/_helpers";

export default function Apps() {
    const scrollr = useRef();
    const dispatch = useDispatch();
    const [appHex, setAppHex] = useState('');
    const [selected, setSelected] = useState('');
    const [tech, setTech] = useState('');
    const [technologies, setTechnologies] = useState([]);
    const handleSetTechnologies = (e) => {
        if (
            // e.charCode === 32 ||    // ...if user pressed 'Space' key
            e.charCode === 13       // ...if user pressed 'Enter' key
        ) {
            e.preventDefault();
            const _techs = technologies.map(t => t.toLowerCase());
            if (!_techs.includes(tech.toLowerCase())) {
                technologies.push(tech);
                setTech('');
            }
        }
    }
    const removeTech = (tech) => {
        let _techs = technologies.filter(t => {
            return t !== tech;
        });
        setTechnologies(_techs);
    };
    const [screenshots, setScreenshots] = useState([]);
    const handleSetScreenshots = (url) => {
        if (!screenshots.includes(url.toLowerCase())) {
            let _screenshots = [...screenshots];
            _screenshots.push(url);
            setScreenshots(_screenshots);
        }
    }
    const removeScreenshot = (url) => {
        let _images = screenshots.filter(s => {
            return s !== url;
        });
        setScreenshots(_images);
    };
    const setFilter = (hex) => {
        if (selected === hex) return;
        setAppsCount(0);
        setAppsLimit(appConfigs.apps_limit);
        setSelected(hex);
        dispatch(commonActions.fetchApps({ filter: hex, limit: appConfigs.apps_limit, jwt: authToken }));
    };
    const [processing, setProcessing] = useState(false);
    const [alert, setAlertMsg] = useState(null);
    const setAlert = (data) => {
        setAlertMsg(data);
        scrollr.current?.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const [openEditDialog, setOpenEditDialog] = useState(false);
    const [uploading, setUploading] = useState(false);

    const { authToken, appsLoading, appsLoadingMore, apps, fetchingCategories, categories } = useSelector(
        (state) => ({
            authToken: state.auth.authToken,
            appsLoading: state.apps.actionsLoading,
            appsLoadingMore: state.apps.actionsLoadingMore,
            apps: state.apps.data,
            fetchingCategories: state.categories.actionsLoading,
            categories: state.categories.data,
        }),
        shallowEqual
    );

    const { isAuthorized } = useSelector(
        ({ auth }) => ({
            isAuthorized: auth.user != null && auth.authToken != null,
        }),
        shallowEqual
    );

    const [prefs, setPrefs] = useState({});
    const [initialValues, setInitialValues] = useState({});
    const newSchema = Yup.object().shape({
        title: Yup.string().required(),
        image: Yup.string().required(),
        excerpt: Yup.string(),
        content: Yup.string().required(),
        category: Yup.string().required(),
        technology: Yup.string(),
        url: Yup.string(),
        repoUrl: Yup.string(),
        designUrl: Yup.string(),
        screenshots: Yup.string(),
        startDate: Yup.date().required(),
        completeDate: Yup.date().required(),
        active: Yup.boolean(),
        hidden: Yup.boolean(),
    });

    const addApp = () => {
        setAlert(null);
        setAppHex('');
        setTechnologies([]);
        setScreenshots([]);
        setPrefs({
            title: "New App",
            intro: "Fill in the details below to add a new application to the portfolio",
        });
        setInitialValues({
            title: "",
            image: "",
            excerpt: "",
            content: "",
            category: "",
            technology: "",
            url: "",
            repoUrl: "",
            designUrl: "",
            screenshots: "",
            startDate: "",
            completeDate: "",
            active: true,
            hidden: false,
        });
        setOpenEditDialog(true);
    };

    const editApp = (app) => {
        setAlert(null);
        setAppHex(app?.hex);
        setTechnologies(app?.technologies);
        setScreenshots(app?.screenshots);
        setPrefs({
            title: "Update App",
            intro: "Edit the details below to update the application",
        });
        setInitialValues({
            title: app?.title,
            image: app?.image,
            excerpt: app?.excerpt,
            content: app?.content,
            category: app?.category,
            // technology: "",
            url: app?.url,
            repoUrl: app?.repo_url,
            designUrl: app?.design_url,
            // screenshots: "",
            startDate: formatInputDate(app?.start_date * 1000),
            completeDate: formatInputDate(app?.complete_date * 1000),
            active: (app?.active === 1),
            hidden: (app?.hidden === 1),
        });
        setOpenEditDialog(true);
    };

    const handleCloseEditDialog = (handleReset = () => { }) => {
        setOpenEditDialog(false);
        handleReset();
    };
    const renderEditDialog = () => {
        return (
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validationSchema={newSchema}
                onSubmit={(values) => {
                    setProcessing(true);
                    values['technology'] = JSON.stringify(technologies);
                    values['screenshots'] = JSON.stringify(screenshots);
                    values['dateStarted'] = (new Date(values.startDate)).getTime() / 1000;
                    values['dateCompleted'] = (new Date(values.completeDate)).getTime() / 1000;
                    values['isActive'] = (values.active) ? 1 : 0;
                    values['isHidden'] = (values.hidden) ? 1 : 0;
                    values['jwt'] = authToken;
                    if (appHex !== '') {
                        values['hex'] = appHex;
                        updateApp(values)
                            .then((resp) => {
                                // console.log(resp.data);
                                if (resp.data.response_code === 1) {
                                    setAppsCount(0);
                                    setAppsLimit(appConfigs.apps_limit);
                                    setAlert({ type: 'success', msg: `The app was updated successfully.` });
                                    dispatch(commonActions.fetchApps({ filter: selected, limit: appConfigs.apps_limit, jwt: authToken }));
                                    setTimeout(() => {
                                        handleCloseEditDialog();
                                        setProcessing(false);
                                    }, 3000);
                                } else {
                                    setAlert({ type: 'error', msg: `An error occurred. Please try again.` });
                                    setProcessing(false);
                                }
                            })
                            .catch(() => {
                                setAlert({ type: 'error', msg: `An error occurred. Please try again.` });
                                setProcessing(false);
                            });
                    } else {
                        createApp(values)
                            .then((resp) => {
                                // console.log(resp.data);
                                if (resp.data.response_code === 1) {
                                    setAppsCount(0);
                                    setAppsLimit(appConfigs.apps_limit);
                                    setAlert({ type: 'success', msg: `The app was added successfully.` });
                                    dispatch(commonActions.fetchApps({ filter: selected, limit: appConfigs.apps_limit, jwt: authToken }));
                                    setTimeout(() => {
                                        handleCloseEditDialog();
                                        setProcessing(false);
                                    }, 3000);
                                } else {
                                    setAlert({ type: 'error', msg: `An error occurred. Please try again.` });
                                    setProcessing(false);
                                }
                            })
                            .catch(() => {
                                setAlert({ type: 'error', msg: `An error occurred. Please try again.` });
                                setProcessing(false);
                            });
                    }
                }}>
                {({ values, errors, touched, handleChange, handleSubmit, handleReset, setFieldValue, getFieldProps }) => {
                    return (
                        <React.Fragment>
                            <Dialog
                                open={openEditDialog}
                                onClose={() => handleCloseEditDialog(handleReset)}
                                aria-labelledby="form-dialog-title"
                                fullWidth={true}
                                maxWidth={"sm"}
                                disableEscapeKeyDown={true}
                                disableBackdropClick={true}
                            >
                                <DialogTitle id="form-dialog-title" style={{ fontWeight: '900', paddingBottom: '0' }}>{prefs?.title}</DialogTitle>
                                <DialogContent className="martin-scrollbar" ref={scrollr}>
                                    {alert && <Alert onClose={() => setAlert(null)} severity={alert.type} style={{ marginBottom: '20px' }}><div dangerouslySetInnerHTML={{ __html: alert.msg }} /></Alert>}
                                    <p style={{ lineHeight: '1.2', fontSize: '0.875rem', marginBottom: '0.75em' }}>{prefs?.intro}</p>
                                    <TextField
                                        autoFocus
                                        color="secondary"
                                        autoComplete="off"
                                        name="title"
                                        value={values.title}
                                        onChange={handleChange}
                                        margin="dense"
                                        id="title"
                                        type="text"
                                        disabled={processing || uploading}
                                        error={Boolean(errors.title && touched.title)}
                                        // {...getFieldProps("title")}
                                        label="App title"
                                        helperText="Application title"
                                        fullWidth
                                        style={{ marginBottom: '1em' }}
                                    />
                                    {(values.image !== '') && <FilePreviewer
                                        title={"App image"}
                                        description={"Preferred dimensions are 800x533, maximum size allowed is 512KB, and allowed file types are *.jpg, *.jpeg and *.png"}
                                        url={values.image}
                                        deletingStatus={setUploading}
                                        deleted={(v) => { if (v) setFieldValue('image', ''); }}
                                        alert={setAlert}
                                    />}
                                    {(values.image === '') && <FileUploader
                                        title={"App image"}
                                        description={"Preferred dimensions are 800x533, maximum size allowed is 512KB, and allowed file types are *.jpg, *.jpeg and *.png"}
                                        type={'image'}
                                        enabled={processing}
                                        uploadingStatus={setUploading}
                                        uploaded={(v) => setFieldValue('image', v?.url)}
                                        alert={setAlert}
                                        limitSize={(512 * 1024)}
                                        limitExtensions={['png', 'jpg', 'jpeg']}
                                        error={Boolean(errors.image && touched.image)}
                                    />}
                                    <ContentEditor
                                        title={"Content"}
                                        value={values.content}
                                        output={(c) => { setFieldValue('content', c?.html); setFieldValue('excerpt', c?.text); }}
                                        error={Boolean(errors.content && touched.content)}
                                        disabled={processing || uploading}
                                    />
                                    <TextField
                                        color="secondary"
                                        autoComplete="off"
                                        name="tech"
                                        value={tech}
                                        onChange={(e) => setTech(e.target.value)}
                                        onKeyPress={(e) => handleSetTechnologies(e)}
                                        margin="dense"
                                        id="tech"
                                        type="text"
                                        disabled={processing || uploading}
                                        label="App technology"
                                        helperText="Type and press 'Enter' to add"
                                        fullWidth
                                        style={{ marginBottom: '10px', marginTop: '12px' }}
                                    />
                                    {technologies.map((tech, i) => {
                                        return <Chip
                                            key={i}
                                            label={tech}
                                            clickable={false}
                                            disabled={processing || uploading}
                                            color={"default"}
                                            onDelete={() => removeTech(tech)}
                                            style={{ marginBottom: '10px', marginRight: '10px', fontFamily: 'roboto' }}
                                        />
                                    })}
                                    <div className="row">
                                        <div className="col-md-6">
                                            <FormControl style={{ width: '100%', marginBottom: '10px', marginTop: '0' }} error={Boolean(errors.category && touched.category)}>
                                                <InputLabel id="category-label" >Category</InputLabel>
                                                <Select
                                                    labelId="category-label"
                                                    color="secondary"
                                                    id="category"
                                                    value={values.category}
                                                    name="category"
                                                    onChange={handleChange}
                                                    disabled={processing || uploading}
                                                >
                                                    {categories.map((category) => {
                                                        return (category.type === 'apps') && <MenuItem key={category.hex} value={category.hex}>{category.name}</MenuItem>
                                                    })}
                                                </Select>
                                                <FormHelperText>App category</FormHelperText>
                                            </FormControl>
                                        </div>
                                        <div className="col-md-6">
                                            <TextField
                                                color="secondary"
                                                autoComplete="off"
                                                name="url"
                                                value={values.url}
                                                onChange={handleChange}
                                                margin="dense"
                                                id="url"
                                                type="text"
                                                disabled={processing || uploading}
                                                error={Boolean(errors.url && touched.url)}
                                                // {...getFieldProps("url")}
                                                label="App URL"
                                                helperText="Application URL"
                                                fullWidth
                                                style={{ marginBottom: '10px', marginTop: '3px' }}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <TextField
                                                color="secondary"
                                                autoComplete="off"
                                                name="repoUrl"
                                                value={values.repoUrl}
                                                onChange={handleChange}
                                                margin="dense"
                                                id="repoUrl"
                                                type="text"
                                                disabled={processing || uploading}
                                                error={Boolean(errors.repoUrl && touched.repoUrl)}
                                                // {...getFieldProps("repoUrl")}
                                                label="App repository URL"
                                                helperText="Application repository URL"
                                                fullWidth
                                                style={{ marginBottom: '10px', marginTop: '0' }}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <TextField
                                                color="secondary"
                                                autoComplete="off"
                                                name="designUrl"
                                                value={values.designUrl}
                                                onChange={handleChange}
                                                margin="dense"
                                                id="designUrl"
                                                type="text"
                                                disabled={processing || uploading}
                                                error={Boolean(errors.designUrl && touched.designUrl)}
                                                // {...getFieldProps("designUrl")}
                                                label="App design URL"
                                                helperText="URL to the app designs"
                                                fullWidth
                                                style={{ marginBottom: '10px', marginTop: '0' }}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <TextField
                                                color="secondary"
                                                autoComplete="off"
                                                name="startDate"
                                                value={values.startDate}
                                                onChange={handleChange}
                                                margin="dense"
                                                id="startDate"
                                                type="date"
                                                disabled={processing || uploading}
                                                error={Boolean(errors.startDate && touched.startDate)}
                                                // {...getFieldProps("startDate")}
                                                label="Start date"
                                                helperText="Project start date"
                                                InputLabelProps={{ shrink: true }}
                                                fullWidth
                                                style={{ marginBottom: '10px', marginTop: '0' }}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <TextField
                                                color="secondary"
                                                autoComplete="off"
                                                name="completeDate"
                                                value={values.completeDate}
                                                onChange={handleChange}
                                                margin="dense"
                                                id="completeDate"
                                                type="date"
                                                disabled={processing || uploading}
                                                error={Boolean(errors.completeDate && touched.completeDate)}
                                                // {...getFieldProps("completeDate")}
                                                label="Complete date"
                                                helperText="Project complete date"
                                                InputLabelProps={{ shrink: true }}
                                                fullWidth
                                                style={{ marginBottom: '10px', marginTop: '0' }}
                                            />
                                        </div>
                                    </div>
                                    <div className="d-block">
                                        <FileUploader
                                            title={"App screenshots"}
                                            description={"Maximum size allowed is 512KB, and allowed file types are *.jpg, *.jpeg and *.png"}
                                            type={'image'}
                                            enabled={processing}
                                            uploadingStatus={setUploading}
                                            uploaded={(v) => handleSetScreenshots(v?.url)}
                                            alert={setAlert}
                                            limitSize={(512 * 1024)}
                                            limitExtensions={['png', 'jpg', 'jpeg']}
                                        />
                                        {screenshots.map((s, i) => {
                                            return (<FilePreviewer
                                                key={i}
                                                url={s}
                                                deletingStatus={setUploading}
                                                deleted={(v) => { if (v) removeScreenshot(s); }}
                                                alert={setAlert}
                                            />)
                                        })}
                                    </div>
                                    <div className="d-block">
                                        <FormControlLabel
                                            style={{ marginBottom: '0', marginTop: '10px' }}
                                            control={
                                                <Checkbox
                                                    checked={values.active}
                                                    onChange={handleChange}
                                                    disabled={processing || uploading}
                                                    name="active"
                                                    color="secondary"
                                                />
                                            }
                                            label="Application is active (Means it's 'archived' if not checked)"
                                        />
                                    </div>
                                    <div className="d-block">
                                        <FormControlLabel
                                            style={{ marginBottom: '10px', marginTop: '0' }}
                                            control={
                                                <Checkbox
                                                    checked={values.hidden}
                                                    onChange={handleChange}
                                                    disabled={processing || uploading}
                                                    name="hidden"
                                                    color="secondary"
                                                />
                                            }
                                            label="Application is hidden (Means it's only visible for authenticated users)"
                                        />
                                    </div>
                                </DialogContent>
                                <DialogActions style={{ padding: '20px' }}>
                                    <Button
                                        onClick={() => handleCloseEditDialog(handleReset)}
                                        color="secondary"
                                        style={{ marginRight: '10px' }}
                                        disabled={processing || uploading}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={handleSubmit}
                                        disabled={processing || uploading}
                                        type="submit"
                                    >
                                        Save Changes
                                        {processing && <CircularProgress
                                            variant="indeterminate"
                                            color={'inherit'}
                                            size={16}
                                            thickness={4}
                                            style={{ marginLeft: '8px' }}
                                        />}
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </React.Fragment>
                    );
                }}
            </Formik>
        );
    };

    const [appsCount, setAppsCount] = useState(0);
    const [appsLimit, setAppsLimit] = useState(appConfigs.apps_limit);

    const loadMoreApps = () => {
        setAppsCount(apps?.length);
        setAppsLimit(appsLimit + appConfigs.apps_limit);
        dispatch(commonActions.fetchApps({ filter: selected, limit: (appsLimit + appConfigs.apps_limit), jwt: authToken }, true));
    };

    useEffect(() => {
        dispatch(commonActions.fetchApps({ filter: '', limit: appConfigs.apps_limit, jwt: authToken }));
    }, [dispatch, authToken]);

    return (
        <>
            <div className="martin-narrow-content content-section">
                <PageTitle heading={"Mobile & Web Apps"} headingMeta={"Portfolio"} />
                <PortfolioCategories
                    setFilter={setFilter}
                    categories={categories}
                    fetchingCategories={fetchingCategories}
                    selected={selected}
                    type={'apps'}
                    isAuthorized={isAuthorized}
                    addNew={addApp}
                />
                <div className="row">
                    <div className="col-md-12 col-md-offset-3 col-md-pull-3">
                        {appsLoading && <div style={{ display: 'block', marginTop: '20px' }}>
                            <ContentLoader
                                width={350}
                                height={280}
                                viewBox="0 0 350 280"
                                backgroundColor="var(--mn-shimmer-background)"
                                foregroundColor="var(--mn-shimmer-foreground)"
                                style={{ 'marginRight': '15px' }}
                            >
                                <rect x="0" y="0" rx="10" ry="10" width="348" height="217" />
                                <rect x="0" y="232" rx="4" ry="4" width="271" height="9" />
                                <rect x="0" y="252" rx="3" ry="3" width="119" height="6" />
                            </ContentLoader>
                            <ContentLoader
                                width={350}
                                height={280}
                                viewBox="0 0 350 280"
                                backgroundColor="var(--mn-shimmer-background)"
                                foregroundColor="var(--mn-shimmer-foreground)"
                                className="smaller-devices-hide"
                            >
                                <rect x="0" y="0" rx="10" ry="10" width="348" height="217" />
                                <rect x="0" y="232" rx="4" ry="4" width="271" height="9" />
                                <rect x="0" y="252" rx="3" ry="3" width="119" height="6" />
                            </ContentLoader>
                        </div>}
                        {(!appsLoading) && apps.map((app, i) => {
                            return (<PortfolioCard
                                key={`portfolio-${i}`}
                                editApp={editApp}
                                app={app}
                                isAuthorized={isAuthorized}
                            />)
                        })}
                        {(apps?.length === 0 && !appsLoading) && <React.Fragment>
                            {/* <img src={toAbsoluteUrl('/_media/images/empty.svg')} alt="nothing" style={{ maxWidth: '320px', margin: '40px 0 20px 0' }} /> */}
                            <p className="opacity-70" style={{ margin: '40px 0 20px 0' }}>
                                <strong>No apps found</strong>
                                <small style={{ display: 'block', lineHeight: '1' }}>There's nothing to display</small>
                            </p>
                        </React.Fragment>}
                    </div>
                </div>
                <div className="load-more">
                    {((apps?.length > appsCount) || !appsLoading) && <Button
                        variant={((apps?.length === appsCount) && !appsLoadingMore) ? "text" : "outlined"}
                        color={((apps?.length === appsCount) && !appsLoadingMore) ? "default" : "secondary"}
                        onClick={() => loadMoreApps()}
                        disabled={(apps?.length === appsCount) || appsLoadingMore}
                        className={((apps?.length === appsCount) && !appsLoadingMore) ? "default-theme-btn" : ""}
                    >
                        {((apps?.length === appsCount) && !appsLoadingMore) ? 'No more Apps to show' : 'Load more Apps'}
                        {appsLoadingMore && <CircularProgress
                            variant="indeterminate"
                            color={'inherit'}
                            size={16}
                            thickness={4}
                            style={{ marginLeft: '8px' }}
                        />}
                    </Button>}
                </div>
                {isAuthorized && renderEditDialog()}
            </div>
        </>
    );
}